import { render, staticRenderFns } from "./DisablePluginsModal.vue?vue&type=template&id=8b9d1bd4&"
import script from "./DisablePluginsModal.vue?vue&type=script&lang=js&"
export * from "./DisablePluginsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b9d1bd4')) {
      api.createRecord('8b9d1bd4', component.options)
    } else {
      api.reload('8b9d1bd4', component.options)
    }
    module.hot.accept("./DisablePluginsModal.vue?vue&type=template&id=8b9d1bd4&", function () {
      api.rerender('8b9d1bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Wordpress/Modals/DisablePluginsModal.vue"
export default component.exports